<template>
     <div class="qingwu">
        <div class="shop_top"><shop-top :subnav_show="false" :change_color="true"></shop-top></div>
<img @click="go_51bencao()" class="page_img" src="https://www.sckxyy.com/imgs/imgs/sckxyy/image/51bencao.jpg">

        <ShopMbar></ShopMbar>
        <shop-foot></shop-foot>
    </div>
</template>

<script>
import Clipboard from 'clipboard';  
import ShopTop from "@/components/home/public/head.vue"
import ShopFoot from "@/components/home/public/shop_foot.vue"
import ShopMbar from "@/components/home/public/mui_mbar_tabs.vue"
export default {
    components: {
        ShopTop,
        ShopFoot,
        ShopMbar
    },
    data() {
      return {
          list:[],
          company:null,
      };
    },
    methods: {  
        go_51bencao:function(){
            this.$confirm('授权使用单位、个人信息登陆芸欣医药网?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(()=>{
                    let url='https://www.51bencao.net/user/login_kx?userId=' +this.companyId;
                    window.location.replace(url);
                // this.$router.push('https://www.51bencao.net/user/login_kx?userId='+this.companyId);
                //this.get_user_info();
            });
        },

        get_user_info:function(){
            this.$get(this.$api.homeGetUserInfo).then(res=>{
                if(res.code==200){
                    this.user_info = res.data;
                    this.get_goBencao();
                }else if(res.code == 401){
                    // this.$router.push('/'); 
                }else{
                    // this.$router.push('/'); 
                }

            });
        },

        //跳转芸欣
        get_goBencao:function(){
            this.$get(this.$api.goBencao,{companyId:this.user_info.company}).then(res=>{
                if(res.code == 200){
                    this.companyId = res.data;
                }else{
                    // this.$router.push('/'); 
                }
            })
        }
    },
    created() {
        this.get_user_info();
    },
    mounted() {
    }
};
</script>
<style>
    .copy_link{
        cursor: pointer;
    }
    .copy_link:hover{
        color: #fa0808;
    }
    .page_img{
        width: 100%;
        cursor: pointer;
    }
</style>